module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0086":
/***/ (function(module, exports, __webpack_require__) {

/**
 *
 * @author    Jerry Bendy
 * @since     4/12/2017
 */

function touchX(event) {
    if(event.type.indexOf('mouse') !== -1){
        return event.clientX;
    }
    return event.touches[0].clientX;
}

function touchY(event) {
    if(event.type.indexOf('mouse') !== -1){
        return event.clientY;
    }
    return event.touches[0].clientY;
}

var isPassiveSupported = (function() {
    var supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function() {
                supportsPassive = true;
            }
        });
        window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassive;
})();


var vueTouchEvents = {
    install: function (Vue, constructorOptions) {

        var globalOptions = Object.assign({}, {
            disableClick: false,
            tapTolerance: 10,  // px
            swipeTolerance: 30,  // px
            touchHoldTolerance: 400,  // ms
            longTapTimeInterval: 400,  // ms
            touchClass: ''
        }, constructorOptions);

        function touchStartEvent(event) {
            var $this = this.$$touchObj,
                isTouchEvent = event.type.indexOf('touch') >= 0,
                isMouseEvent = event.type.indexOf('mouse') >= 0,
                $el = this;

            if (isTouchEvent) {
                $this.lastTouchStartTime = event.timeStamp;
            }

            if (isMouseEvent && $this.lastTouchStartTime && event.timeStamp - $this.lastTouchStartTime < 350) {
                return;
            }

            if ($this.touchStarted) {
                return;
            }

            addTouchClass(this);

            $this.touchStarted = true;

            $this.touchMoved = false;
            $this.swipeOutBounded = false;

            $this.startX = touchX(event);
            $this.startY = touchY(event);

            $this.currentX = 0;
            $this.currentY = 0;

            $this.touchStartTime = event.timeStamp;

            // Trigger touchhold event after `touchHoldTolerance`ms
            $this.touchHoldTimer = setTimeout(function() {
                triggerEvent(event, $el, 'touchhold');
            }, $this.options.touchHoldTolerance);

            triggerEvent(event, this, 'start');
        }

        function touchMoveEvent(event) {
            var $this = this.$$touchObj;

            $this.currentX = touchX(event);
            $this.currentY = touchY(event);

            if (!$this.touchMoved) {
                var tapTolerance = $this.options.tapTolerance;

                $this.touchMoved = Math.abs($this.startX - $this.currentX) > tapTolerance ||
                    Math.abs($this.startY - $this.currentY) > tapTolerance;

                if($this.touchMoved){
                    cancelTouchHoldTimer($this);
                    triggerEvent(event, this, 'moved');
                }

            } else if (!$this.swipeOutBounded) {
                var swipeOutBounded = $this.options.swipeTolerance;

                $this.swipeOutBounded = Math.abs($this.startX - $this.currentX) > swipeOutBounded &&
                    Math.abs($this.startY - $this.currentY) > swipeOutBounded;
            }

            if($this.touchMoved){
                triggerEvent(event, this, 'moving');
            }
        }

        function touchCancelEvent() {
            var $this = this.$$touchObj;

            cancelTouchHoldTimer($this);
            removeTouchClass(this);

            $this.touchStarted = $this.touchMoved = false;
            $this.startX = $this.startY = 0;
        }

        function touchEndEvent(event) {
            var $this = this.$$touchObj,
                isTouchEvent = event.type.indexOf('touch') >= 0,
                isMouseEvent = event.type.indexOf('mouse') >= 0;

            if (isTouchEvent) {
                $this.lastTouchEndTime = event.timeStamp;
            }

            cancelTouchHoldTimer($this);

            $this.touchStarted = false;

            removeTouchClass(this);

            if (isMouseEvent && $this.lastTouchEndTime && event.timeStamp - $this.lastTouchEndTime < 350) {
                return;
            }

            // Fix #33, Trigger `end` event when touch stopped
            triggerEvent(event, this, 'end');

            if (!$this.touchMoved) {
                // detect if this is a longTap event or not
                if ($this.callbacks.longtap && event.timeStamp - $this.touchStartTime > $this.options.longTapTimeInterval) {
                    if (event.cancelable) {
                        event.preventDefault();
                    }
                    triggerEvent(event, this, 'longtap');

                } else {
                    // emit tap event
                    triggerEvent(event, this, 'tap');
                }

            } else if (!$this.swipeOutBounded) {
                var swipeOutBounded = $this.options.swipeTolerance,
                    direction;

                if (Math.abs($this.startX - $this.currentX) < swipeOutBounded) {
                    direction = $this.startY > $this.currentY ? 'top' : 'bottom';

                } else {
                    direction = $this.startX > $this.currentX ? 'left' : 'right';
                }

                // Only emit the specified event when it has modifiers
                if ($this.callbacks['swipe.' + direction]) {
                    triggerEvent(event, this, 'swipe.' + direction, direction);

                } else {
                    // Emit a common event when it has no any modifier
                    triggerEvent(event, this, 'swipe', direction);
                }
            }
        }

        function mouseEnterEvent() {
            addTouchClass(this);
        }

        function mouseLeaveEvent() {
            removeTouchClass(this);
        }

        function triggerEvent(e, $el, eventType, param) {
            var $this = $el.$$touchObj;

            // get the callback list
            var callbacks = $this.callbacks[eventType] || [];
            if (callbacks.length === 0) {
                return null;
            }

            for (var i = 0; i < callbacks.length; i++) {
                var binding = callbacks[i];

                if (binding.modifiers.stop) {
                    e.stopPropagation();
                }

                if (binding.modifiers.prevent) {
                    e.preventDefault();
                }

                // handle `self` modifier`
                if (binding.modifiers.self && e.target !== e.currentTarget) {
                    continue;
                }

                if (typeof binding.value === 'function') {
                    if (param) {
                        binding.value(param, e);
                    } else {
                        binding.value(e);
                    }
                }
            }
        }

        function addTouchClass($el) {
            var className = $el.$$touchObj.options.touchClass;
            className && $el.classList.add(className);
        }

        function removeTouchClass($el) {
            var className = $el.$$touchObj.options.touchClass;
            className && $el.classList.remove(className);
        }

        function cancelTouchHoldTimer($this) {
            if ($this.touchHoldTimer) {
                clearTimeout($this.touchHoldTimer);
                $this.touchHoldTimer = null;
            }
        }

        function buildTouchObj($el, extraOptions) {
            var touchObj = $el.$$touchObj || {
                // an object contains all callbacks registered,
                // key is event name, value is an array
                callbacks: {},
                // prevent bind twice, set to true when event bound
                hasBindTouchEvents: false,
                // default options, would be override by v-touch-options
                options: globalOptions
            };
            if (extraOptions) {
                touchObj.options = Object.assign({}, touchObj.options, extraOptions);
            }
            $el.$$touchObj = touchObj;
            return $el.$$touchObj;
        }

        Vue.directive('touch', {
            bind: function ($el, binding) {
                // build a touch configuration object
                var $this = buildTouchObj($el);
                // declare passive option for the event listener. Defaults to { passive: true } if supported
                var passiveOpt = isPassiveSupported ? { passive: true } : false;
                // register callback
                var eventType = binding.arg || 'tap';
                switch (eventType) {
                    case 'swipe':
                        var _m = binding.modifiers;
                        if (_m.left || _m.right || _m.top || _m.bottom) {
                            for (var i in binding.modifiers) {
                                if (['left', 'right', 'top', 'bottom'].indexOf(i) >= 0) {
                                    var _e = 'swipe.' + i;
                                    $this.callbacks[_e] = $this.callbacks[_e] || [];
                                    $this.callbacks[_e].push(binding);
                                }
                            }
                        } else {
                            $this.callbacks.swipe = $this.callbacks.swipe || [];
                            $this.callbacks.swipe.push(binding);
                        }
                        break;
                    
                    case 'start':
                    case 'moving':
                        if (binding.modifiers.disablePassive) {
                            // change the passive option for the moving event if disablePassive modifier exists
                            passiveOpt = false;
                        }
                    default:
                        $this.callbacks[eventType] = $this.callbacks[eventType] || [];
                        $this.callbacks[eventType].push(binding);
                }

                // prevent bind twice
                if ($this.hasBindTouchEvents) {
                    return;
                }

                $el.addEventListener('touchstart', touchStartEvent, passiveOpt);
                $el.addEventListener('touchmove', touchMoveEvent, passiveOpt);
                $el.addEventListener('touchcancel', touchCancelEvent);
                $el.addEventListener('touchend', touchEndEvent);

                if (!$this.options.disableClick) {
                    $el.addEventListener('mousedown', touchStartEvent);
                    $el.addEventListener('mousemove', touchMoveEvent);
                    $el.addEventListener('mouseup', touchEndEvent);
                    $el.addEventListener('mouseenter', mouseEnterEvent);
                    $el.addEventListener('mouseleave', mouseLeaveEvent);
                }

                // set bind mark to true
                $this.hasBindTouchEvents = true;
            },

            unbind: function ($el) {
                $el.removeEventListener('touchstart', touchStartEvent);
                $el.removeEventListener('touchmove', touchMoveEvent);
                $el.removeEventListener('touchcancel', touchCancelEvent);
                $el.removeEventListener('touchend', touchEndEvent);

                if ($el.$$touchObj && !$el.$$touchObj.options.disableClick) {
                    $el.removeEventListener('mousedown', touchStartEvent);
                    $el.removeEventListener('mousemove', touchMoveEvent);
                    $el.removeEventListener('mouseup', touchEndEvent);
                    $el.removeEventListener('mouseenter', mouseEnterEvent);
                    $el.removeEventListener('mouseleave', mouseLeaveEvent);
                }

                // remove vars
                delete $el.$$touchObj;
            }
        });

        Vue.directive('touch-class', {
            bind: function ($el, binding) {
                buildTouchObj($el, {
                    touchClass: binding.value
                });
            }
        });

        Vue.directive('touch-options', {
            bind: function($el, binding) {
                buildTouchObj($el, binding.value);
            }
        });
    }
};


/*
 * Exports
 */
if (true) {
    module.exports = vueTouchEvents;

} else {}


/***/ }),

/***/ "0a06":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var buildURL = __webpack_require__("30b5");
var InterceptorManager = __webpack_require__("f6b4");
var dispatchRequest = __webpack_require__("5270");
var mergeConfig = __webpack_require__("4a7b");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "0df6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "1d2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "2444":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("c532");
var normalizeHeaderName = __webpack_require__("c8af");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("b50d");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("b50d");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "2d83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("387f");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "2e67":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "30b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "387f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "3934":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "4362":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("df7c");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "467f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("2d83");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "4a7b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),

/***/ "5270":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var transformData = __webpack_require__("c401");
var isCancel = __webpack_require__("2e67");
var defaults = __webpack_require__("2444");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "7a77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "7aac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "83b9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("d925");
var combineURLs = __webpack_require__("e683");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "8df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("7a77");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "975c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b50d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var settle = __webpack_require__("467f");
var buildURL = __webpack_require__("30b5");
var buildFullPath = __webpack_require__("83b9");
var parseHeaders = __webpack_require__("c345");
var isURLSameOrigin = __webpack_require__("3934");
var createError = __webpack_require__("2d83");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("7aac");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "bc3a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cee4");

/***/ }),

/***/ "c345":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "c401":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "c532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("1d2b");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "c8af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "cee4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var bind = __webpack_require__("1d2b");
var Axios = __webpack_require__("0a06");
var mergeConfig = __webpack_require__("4a7b");
var defaults = __webpack_require__("2444");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("7a77");
axios.CancelToken = __webpack_require__("8df4");
axios.isCancel = __webpack_require__("2e67");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("0df6");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "d925":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "dad5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleReviews_vue_vue_type_style_index_0_id_00c7b4dd_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("975c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleReviews_vue_vue_type_style_index_0_id_00c7b4dd_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GoogleReviews_vue_vue_type_style_index_0_id_00c7b4dd_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "df7c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "e683":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "e7c1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ReviewSlider_vue_vue_type_style_index_0_id_17be09ba_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f2ea");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ReviewSlider_vue_vue_type_style_index_0_id_17be09ba_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ReviewSlider_vue_vue_type_style_index_0_id_17be09ba_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f2ea":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f6b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("bc3a");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/services/API.js


/* harmony default export */ var API = ({

    post(url, request) {
        return axios_default.a.post(url, request)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    get(url, params) {

        return axios_default.a.get(url, {
            params: params
        })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => {
                return Promise.reject(error);
            });
    }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0b95d284-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GoogleReviews.vue?vue&type=template&id=00c7b4dd
var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.place)?_c('div',{staticClass:"google-reviews"},[_c('div',{staticClass:"stars"},_vm._l((5),function(i){return _c('star',{key:`b${i}`,attrs:{"i":i,"score":_vm.place.rating}})}),1),_c('h2',{staticClass:"google-rating"},[_vm._v(_vm._s(_vm.place.rating)+" Google Rating")]),_c('p',{staticClass:"rating-subhead"},[_vm._v(_vm._s(_vm.place.rating_count.toLocaleString('en-ZA'))+" people just like you rate Afrihost the best ISP in SA")]),_c('review-slider',{attrs:{"reviews":_vm.reviews},on:{"cta":function($event){return _vm.handleCta()}}}),_c('svg',{staticStyle:{"display":"none"}},[_c('symbol',{attrs:{"viewBox":"0 0 36 33","id":"star-full"}},[_c('polygon',{attrs:{"fill":"#F4AC0D","points":"18 27 7.41986546 32.5623059 9.44049135 20.7811529 0.880982707 12.4376941 12.7099327 10.7188471 18 0 23.2900673 10.7188471 35.1190173 12.4376941 26.5595086 20.7811529 28.5801345 32.5623059"}})]),_c('symbol',{attrs:{"viewBox":"0 0 36 33","id":"star-half"}},[_c('polygon',{attrs:{"fill":"#E0E0E0","points":"18 27 7.41986546 32.5623059 9.44049135 20.7811529 0.880982707 12.4376941 12.7099327 10.7188471 18 0 23.2900673 10.7188471 35.1190173 12.4376941 26.5595086 20.7811529 28.5801345 32.5623059"}}),_c('polygon',{attrs:{"fill":"#F4AC0D","points":"18 27 7.41986546 32.5623059 9.44049135 20.7811529 0.880982707 12.4376941 12.7099327 10.7188471 18 0"}})]),_c('symbol',{attrs:{"viewBox":"0 0 36 33","id":"star-empty"}},[_c('polygon',{attrs:{"fill":"#E0E0E0","points":"18 27 7.41986546 32.5623059 9.44049135 20.7811529 0.880982707 12.4376941 12.7099327 10.7188471 18 0 23.2900673 10.7188471 35.1190173 12.4376941 26.5595086 20.7811529 28.5801345 32.5623059"}})]),_c('symbol',{attrs:{"viewBox":"0 0 12 18","id":"chevron-left"}},[_c('polygon',{attrs:{"points":"10.3133765 0.272986847 11.6866235 1.72701315 3.457 9.5 11.6866235 17.2729868 10.3133765 18.7270132 0.543597835 9.5"}})]),_c('symbol',{attrs:{"viewBox":"0 0 12 18","id":"chevron-right"}},[_c('polygon',{attrs:{"points":"0.313376467 1.72701315 1.68662353 0.272986847 11.4564022 9.5 1.68662353 18.7270132 0.313376467 17.2729868 8.543 9.5"}})])])],1):_vm._e()
}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/GoogleReviews.vue?vue&type=template&id=00c7b4dd

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0b95d284-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Star.vue?vue&type=template&id=c785cf88
var Starvue_type_template_id_c785cf88_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star"},[_c('svg',[_c('use',{attrs:{"href":`#star-${_vm.star}`}})])])
}
var Starvue_type_template_id_c785cf88_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Star.vue?vue&type=template&id=c785cf88

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Star.vue?vue&type=script&lang=js

/* harmony default export */ var Starvue_type_script_lang_js = ({
	props: ['i', 'score'],
	computed: {
		star() {
			let score = parseFloat(this.score),
				index = this.i;

			if(score >= index) {
				return 'full';
			}

			if(Math.ceil(score) === index) {
				return 'half';
			}

			return 'empty';

		}
	}
});

// CONCATENATED MODULE: ./src/components/Star.vue?vue&type=script&lang=js
 /* harmony default export */ var components_Starvue_type_script_lang_js = (Starvue_type_script_lang_js); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/Star.vue





/* normalize component */

var component = normalizeComponent(
  components_Starvue_type_script_lang_js,
  Starvue_type_template_id_c785cf88_render,
  Starvue_type_template_id_c785cf88_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Star = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0b95d284-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ReviewSlider.vue?vue&type=template&id=17be09ba
var ReviewSlidervue_type_template_id_17be09ba_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-slider"},[_c('div',{staticClass:"review-slider"},[_c('div',{staticClass:"intro-tag"},[_c('p',[_vm._v("Here's what our")]),_c('span',[_c('svg',{attrs:{"width":"109px","height":"45px","viewBox":"0 0 109 45"}},[_c('path',{attrs:{"d":"M5.66,34.184 C6.47266667,34.2146667 7.17033333,34.1686667 7.753,34.046 C11.4943333,33.402 15.435,31.3473333 19.575,27.882 C19.759,27.6673333 19.828,27.4526667 19.782,27.238 C19.736,27.0233333 19.5826667,26.87 19.322,26.778 C19.0613333,26.686 18.8236667,26.732 18.609,26.916 C14.1316667,30.688 9.79233333,32.6813333 5.591,32.896 C4.18033333,32.9573333 3.09933333,32.643 2.348,31.953 C1.59666667,31.263 1.38966667,30.2586667 1.727,28.94 C2.003,27.9893333 2.647,27.0233333 3.659,26.042 C4.14966667,25.6433333 4.68633333,25.3213333 5.269,25.076 C5.453,25.0146667 5.706,24.961 6.028,24.915 C6.35,24.869 6.695,24.8536667 7.063,24.869 C7.431,24.8843333 7.67633333,25.0146667 7.799,25.26 C7.92166667,25.5053333 7.86033333,25.8733333 7.615,26.364 C7.49233333,26.6093333 7.5,26.8393333 7.638,27.054 C7.776,27.2686667 7.96,27.376 8.19,27.376 C8.42,27.376 8.61166667,27.2686667 8.765,27.054 C9.28633333,25.9806667 9.34,25.145 8.926,24.547 C8.512,23.949 7.83733333,23.604 6.902,23.512 C5.96666667,23.42 5.085,23.604 4.257,24.064 C2.90766667,24.8 1.842,25.8273333 1.06,27.146 C0.278,28.4646667 0.00966666667,29.8446667 0.255,31.286 C0.377666667,31.9913333 0.730333333,32.574 1.313,33.034 C1.89566667,33.494 2.56266667,33.793 3.314,33.931 C4.06533333,34.069 4.84733333,34.1533333 5.66,34.184 Z M14.86,44.649 C15.09,44.6336667 15.2816667,44.5263333 15.435,44.327 C15.5883333,44.1276667 15.5883333,43.9053333 15.435,43.66 C15.3123333,43.5066667 15.251,43.2843333 15.251,42.993 C15.251,42.7016667 15.274,42.4486667 15.32,42.234 C15.366,42.0193333 15.435,41.728 15.527,41.36 C15.619,40.992 15.6803333,40.7926667 15.711,40.762 C16.0483333,39.3206667 16.6003333,37.4653333 17.367,35.196 C18.1643333,32.8653333 19.0843333,30.4426667 20.127,27.928 C20.219,27.7133333 20.3416667,27.514 20.495,27.33 C26.9656667,19.8473333 31.535,12.6866667 34.203,5.848 C34.7856667,4.34533333 35.077,3.28733333 35.077,2.674 C35.077,2.306 34.9773333,1.95333333 34.778,1.616 C34.5786667,1.27866667 34.249,1.11 33.789,1.11 C33.3903333,1.11 32.9226667,1.32466667 32.386,1.754 C31.8493333,2.18333333 31.2896667,2.812 30.707,3.64 C30.1243333,4.468 29.58,5.273 29.074,6.055 C28.568,6.837 28.0006667,7.84133333 27.372,9.068 C26.7433333,10.2946667 26.2603333,11.2376667 25.923,11.897 C25.5856667,12.5563333 25.1563333,13.4226667 24.635,14.496 C24.4816667,14.8026667 24.3743333,15.0173333 24.313,15.14 C21.5836667,20.7213333 19.0843333,26.5786667 16.815,32.712 C15.6496667,35.932 14.837,38.4926667 14.377,40.394 C14.377,40.4246667 14.331,40.6163333 14.239,40.969 C14.147,41.3216667 14.0933333,41.5593333 14.078,41.682 C14.0626667,41.8046667 14.032,42.027 13.986,42.349 C13.94,42.671 13.917,42.924 13.917,43.108 C13.917,43.292 13.9476667,43.5066667 14.009,43.752 C14.0703333,43.9973333 14.147,44.1966667 14.239,44.35 C14.423,44.5646667 14.63,44.6643333 14.86,44.649 Z M23.531,21.12 C23.347,21.12 23.255,21.0433333 23.255,20.89 C23.255,20.3993333 24.014,18.6513333 25.532,15.646 C27.05,12.6406667 28.66,9.712 30.362,6.86 C32.064,4.008 33.1603333,2.582 33.651,2.582 C34.1723333,2.582 33.651,4.123 32.087,7.205 C30.523,10.287 28.7826667,13.3766667 26.866,16.474 C24.9493333,19.5713333 23.8376667,21.12 23.531,21.12 Z M33.536,21.12 C33.8273333,21.12 34.065,21.028 34.249,20.844 C34.4636667,20.6293333 34.571,20.384 34.571,20.108 C34.571,19.832 34.4713333,19.5943333 34.272,19.395 C34.0726667,19.1956667 33.8273333,19.096 33.536,19.096 C33.2446667,19.096 32.9993333,19.1956667 32.8,19.395 C32.6006667,19.5943333 32.501,19.832 32.501,20.108 C32.501,20.384 32.6006667,20.6216667 32.8,20.821 C32.9993333,21.0203333 33.2446667,21.12 33.536,21.12 Z M30.569,34.874 C30.9983333,34.874 31.397,34.828 31.765,34.736 C32.133,34.644 32.57,34.483 33.076,34.253 C33.582,34.023 33.9653333,33.839 34.226,33.701 C34.4866667,33.563 34.847,33.3713333 35.307,33.126 C35.399,33.0646667 35.4756667,33.0186667 35.537,32.988 C37.9596667,31.608 40.183,29.906 42.207,27.882 C42.391,27.6673333 42.4523333,27.445 42.391,27.215 C42.3296667,26.985 42.1763333,26.8316667 41.931,26.755 C41.6856667,26.6783333 41.4556667,26.732 41.241,26.916 C38.2663333,29.9213333 35.0003333,32.0526667 31.443,33.31 C31.1056667,33.4326667 30.8143333,33.5093333 30.569,33.54 C28.9436667,33.724 28.591,32.344 29.511,29.4 C30.1856667,27.3146667 30.9983333,25.536 31.949,24.064 C32.0716667,23.8186667 32.0793333,23.5963333 31.972,23.397 C31.8646667,23.1976667 31.6806667,23.0903333 31.42,23.075 C31.1593333,23.0596667 30.9523333,23.1593333 30.799,23.374 C30.2776667,24.1406667 29.787,25.0146667 29.327,25.996 C28.867,26.9773333 28.43,28.066 28.016,29.262 C27.602,30.458 27.5023333,31.5543333 27.717,32.551 C27.9316667,33.5476667 28.4836667,34.2453333 29.373,34.644 C29.741,34.7973333 30.1396667,34.874 30.569,34.874 Z M44.001,34.552 C48.325,35.5333333 53.707,33.2333333 60.147,27.652 C60.331,27.4373333 60.3923333,27.2226667 60.331,27.008 C60.2696667,26.7933333 60.1163333,26.64 59.871,26.548 C59.6256667,26.456 59.3956667,26.502 59.181,26.686 C55.8996667,29.538 52.925,31.5006667 50.257,32.574 C49.521,32.8806667 48.693,33.1106667 47.773,33.264 C46.853,33.4173333 45.9176667,33.4633333 44.967,33.402 C44.0163333,33.3406667 43.2266667,33.034 42.598,32.482 C41.9693333,31.93 41.6703333,31.148 41.701,30.136 C41.701,29.8293333 41.7316667,29.5226667 41.793,29.216 C41.9156667,28.848 42.0843333,28.71 42.299,28.802 C43.495,29.3846667 44.9516667,29.4153333 46.669,28.894 C48.3863333,28.3726667 49.4136667,27.5293333 49.751,26.364 C49.9963333,25.7506667 50.0116667,25.0913333 49.797,24.386 C49.5823333,23.6806667 49.107,23.2206667 48.371,23.006 C47.3896667,22.73 46.3776667,22.8296667 45.335,23.305 C44.2923333,23.7803333 43.357,24.4473333 42.529,25.306 C41.517,26.3486667 40.8423333,27.5216667 40.505,28.825 C40.1676667,30.1283333 40.298,31.3243333 40.896,32.413 C41.494,33.5016667 42.529,34.2146667 44.001,34.552 Z M45.358,27.813 C44.5146667,27.9203333 43.7403333,27.8666667 43.035,27.652 C42.9123333,27.6213333 42.8433333,27.537 42.828,27.399 C42.8126667,27.261 42.8356667,27.1306667 42.897,27.008 C43.541,26.0573333 44.5683333,25.2446667 45.979,24.57 C47.635,23.7726667 48.509,23.972 48.601,25.168 C48.6316667,25.812 48.3096667,26.387 47.635,26.893 C46.9603333,27.399 46.2013333,27.7056667 45.358,27.813 Z M67.875,34.828 C68.795,34.828 69.6843333,34.644 70.543,34.276 C71.5856667,33.816 72.7126667,33.1796667 73.924,32.367 C75.1353333,31.5543333 76.04,30.9026667 76.638,30.412 C77.236,29.9213333 78.2403333,29.078 79.651,27.882 C79.835,27.698 79.8963333,27.4986667 79.835,27.284 C79.7736667,27.0693333 79.6126667,26.916 79.352,26.824 C79.0913333,26.732 78.869,26.7626667 78.685,26.916 C78.593,27.008 78.1866667,27.3606667 77.466,27.974 C76.7453333,28.5873333 76.2853333,28.9706667 76.086,29.124 C75.8866667,29.2773333 75.4726667,29.607 74.844,30.113 C74.2153333,30.619 73.7323333,30.9793333 73.395,31.194 C73.0576667,31.4086667 72.613,31.6846667 72.061,32.022 C71.509,32.3593333 70.9876667,32.6353333 70.497,32.85 C70.0063333,33.0646667 69.5003333,33.2486667 68.979,33.402 C68.335,33.6473333 67.8366667,33.7086667 67.484,33.586 C67.1313333,33.4633333 66.8706667,33.287 66.702,33.057 C66.5333333,32.827 66.4566667,32.482 66.472,32.022 C66.4873333,31.562 66.5486667,31.1096667 66.656,30.665 C66.7633333,30.2203333 66.9243333,29.7066667 67.139,29.124 C67.231,28.8786667 67.3383333,28.5873333 67.461,28.25 C67.461,28.25 67.4993333,28.158 67.576,27.974 C67.6526667,27.79 67.714,27.629 67.76,27.491 C67.806,27.353 67.8673333,27.1613333 67.944,26.916 C68.0206667,26.6706667 68.082,26.4483333 68.128,26.249 C68.174,26.0496667 68.2123333,25.835 68.243,25.605 C68.2736667,25.375 68.2736667,25.1756667 68.243,25.007 C68.2123333,24.8383333 68.1663333,24.6696667 68.105,24.501 C68.0436667,24.3323333 67.944,24.2096667 67.806,24.133 C67.668,24.0563333 67.4763333,24.018 67.231,24.018 C66.2496667,24.018 64.425,25.2293333 61.757,27.652 C61.0823333,28.2653333 60.377,28.9246667 59.641,29.63 C59.549,29.7526667 59.4646667,29.791 59.388,29.745 C59.3113333,29.699 59.3036667,29.5993333 59.365,29.446 C60.101,27.8206667 61.2816667,25.4746667 62.907,22.408 C63.0296667,22.1626667 63.0143333,21.9326667 62.861,21.718 C62.7076667,21.5033333 62.516,21.396 62.286,21.396 C62.056,21.396 61.8643333,21.5033333 61.711,21.718 C59.1963333,26.5326667 57.4176667,30.3353333 56.375,33.126 C56.2523333,33.4326667 56.352,33.678 56.674,33.862 C56.996,34.046 57.2643333,34.0153333 57.479,33.77 C58.9816667,32.206 60.5916667,30.6113333 62.309,28.986 C63.781,27.606 65.0536667,26.548 66.127,25.812 C66.311,25.6586667 66.4873333,25.6126667 66.656,25.674 C66.8246667,25.7353333 66.863,25.904 66.771,26.18 C66.587,26.7933333 66.2803333,27.5906667 65.851,28.572 C65.7283333,28.848 65.552,29.377 65.322,30.159 C65.092,30.941 64.977,31.5313333 64.977,31.93 C64.977,33.862 65.943,34.828 67.875,34.828 Z M74.936,43.959 C75.166,43.9436667 75.35,43.8286667 75.488,43.614 C75.626,43.3993333 75.6183333,43.1846667 75.465,42.97 C75.373,42.8166667 75.327,42.5943333 75.327,42.303 C75.327,42.0116667 75.35,41.7586667 75.396,41.544 C75.442,41.3293333 75.511,41.038 75.603,40.67 C75.695,40.302 75.7563333,40.0873333 75.787,40.026 C76.0936667,38.6153333 76.6456667,36.7753333 77.443,34.506 C78.2403333,32.1753333 79.145,29.768 80.157,27.284 C80.2796667,27.0386667 80.4176667,26.8086667 80.571,26.594 C84.4656667,22.1166667 87.6856667,17.716 90.231,13.392 C90.3843333,13.116 90.6296667,12.978 90.967,12.978 C97.8976667,12.886 103.371667,12.84 107.389,12.84 C107.665,12.84 107.856667,12.725 107.964,12.495 C108.071333,12.265 108.071333,12.035 107.964,11.805 C107.856667,11.575 107.665,11.46 107.389,11.46 C103.463667,11.4906667 98.2196667,11.5366667 91.657,11.598 C91.565,11.598 91.496,11.5596667 91.45,11.483 C91.404,11.4063333 91.3963333,11.322 91.427,11.23 C92.5616667,9.14466667 93.5123333,7.12066667 94.279,5.158 C94.8616667,3.65533333 95.153,2.59733333 95.153,1.984 C95.1223333,1.616 95.015,1.26333333 94.831,0.926 C94.647,0.588666667 94.325,0.42 93.865,0.42 C92.1783333,0.42 89.495,4.13066667 85.815,11.552 C85.7843333,11.644 85.7076667,11.69 85.585,11.69 C78.6584222,11.7758667 73.1610474,11.8216622 69.0928756,11.8273867 L68.243,11.828 C67.967,11.828 67.7753333,11.9353333 67.668,12.15 C67.5606667,12.3646667 67.5606667,12.587 67.668,12.817 C67.7753333,13.047 67.967,13.162 68.243,13.162 C72.2603333,13.162 77.7343333,13.116 84.665,13.024 C84.757,13.024 84.826,13.0623333 84.872,13.139 C84.918,13.2156667 84.9256667,13.3 84.895,13.392 C84.8336667,13.5453333 84.7416667,13.7446667 84.619,13.99 C84.4963333,14.2353333 84.4196667,14.3886667 84.389,14.45 C81.2303333,20.89 78.3936667,27.7133333 75.879,34.92 C75.3576667,36.3613333 74.867,38.0173333 74.407,39.888 C74.2536667,40.5013333 74.154,40.9383333 74.108,41.199 C74.062,41.4596667 74.0313333,41.8583333 74.016,42.395 C74.0006667,42.9316667 74.1003333,43.3533333 74.315,43.66 C74.499,43.8746667 74.706,43.9743333 74.936,43.959 Z M89.173,11.644 L87.747,11.644 C87.655,11.644 87.586,11.6056667 87.54,11.529 C87.494,11.4523333 87.4863333,11.368 87.517,11.276 C88.9276667,8.66933333 90.2156667,6.45366667 91.381,4.629 C92.5463333,2.80433333 93.313,1.892 93.681,1.892 C94.1103333,1.892 93.8956667,2.81966667 93.037,4.675 C92.1783333,6.53033333 90.9976667,8.77666667 89.495,11.414 C89.4336667,11.5673333 89.3263333,11.644 89.173,11.644 L89.173,11.644 Z M83.561,20.43 C83.4076667,20.43 83.331,20.3533333 83.331,20.2 C83.331,19.5866667 84.4043333,17.2406667 86.551,13.162 C86.5816667,13.07 86.643,13.024 86.735,13.024 C87.379,12.9933333 87.8543333,12.978 88.161,12.978 C88.253,12.978 88.3296667,13.024 88.391,13.116 C88.4523333,13.208 88.4523333,13.2846667 88.391,13.346 C85.631,18.0686667 84.021,20.43 83.561,20.43 Z M85.24,43.798 C85.838,43.982 86.459,44.0126667 87.103,43.89 C89.3416667,43.3686667 91.6033333,42.165 93.888,40.279 C96.1726667,38.393 97.499,36.4073333 97.867,34.322 C97.959,33.6166667 97.8823333,33.0033333 97.637,32.482 C97.4836667,32.206 97.5603333,31.9913333 97.867,31.838 C100.811,30.366 104.230333,29.0013333 108.125,27.744 C108.370333,27.652 108.508333,27.491 108.539,27.261 C108.569667,27.031 108.516,26.8393333 108.378,26.686 C108.24,26.5326667 108.048333,26.4866667 107.803,26.548 C103.663,27.8973333 100.013667,29.3846667 96.855,31.01 C96.5483333,31.1633333 96.2416667,31.148 95.935,30.964 C95.8736667,30.9333333 95.797,30.8873333 95.705,30.826 C95.521,30.734 95.0303333,30.5116667 94.233,30.159 C93.4356667,29.8063333 92.853,29.492 92.485,29.216 C91.7183333,28.48 91.4346667,27.7593333 91.634,27.054 C91.8333333,26.3486667 92.3853333,25.8196667 93.29,25.467 C94.1946667,25.1143333 94.9843333,25.1833333 95.659,25.674 C95.8736667,25.7966667 96.0653333,25.812 96.234,25.72 C96.4026667,25.628 96.4946667,25.4593333 96.51,25.214 C96.5253333,24.9686667 96.441,24.7846667 96.257,24.662 C95.6743333,24.202 94.9843333,24.0256667 94.187,24.133 C93.3896667,24.2403333 92.6383333,24.4856667 91.933,24.869 C91.2276667,25.2523333 90.6986667,25.789 90.346,26.479 C89.9933333,27.169 89.955,27.882 90.231,28.618 C90.3536667,28.894 90.507,29.147 90.691,29.377 C90.875,29.607 91.128,29.8216667 91.45,30.021 C91.772,30.2203333 92.0173333,30.3736667 92.186,30.481 C92.3546667,30.5883333 92.669,30.7493333 93.129,30.964 C93.589,31.1786667 93.8496667,31.3013333 93.911,31.332 C94.003,31.3626667 94.233,31.4546667 94.601,31.608 C94.7236667,31.6693333 94.785,31.769 94.785,31.907 C94.785,32.045 94.739,32.1446667 94.647,32.206 C91.979,33.7086667 89.6483333,35.3646667 87.655,37.174 C85.0483333,39.5353333 83.883,41.3446667 84.159,42.602 C84.2816667,43.2153333 84.642,43.614 85.24,43.798 Z M86.942,42.625 C86.62,42.7016667 86.2903333,42.7093333 85.953,42.648 C85.6156667,42.5866667 85.4316667,42.4333333 85.401,42.188 C85.2783333,41.4213333 86.321,40.0413333 88.529,38.048 C90.6143333,36.1466667 93.083,34.414 95.935,32.85 C96.211,32.6966667 96.4256667,32.7426667 96.579,32.988 C96.6403333,33.1106667 96.6863333,33.2486667 96.717,33.402 C96.9316667,34.3833333 96.2876667,35.7326667 94.785,37.45 C92.8223333,39.7193333 90.5223333,41.3446667 87.885,42.326 C87.5783333,42.4486667 87.264,42.5483333 86.942,42.625 Z","id":"clients","fill-rule":"nonzero"}})])]),_c('p',[_vm._v("say")])]),_c('div',{staticClass:"arrow left",on:{"click":function($event){return _vm.left()}}},[_c('svg',[_c('use',{attrs:{"href":"#chevron-left"}})])]),_c('div',{staticClass:"arrow right",on:{"click":function($event){return _vm.right()}}},[_c('svg',[_c('use',{attrs:{"href":"#chevron-right"}})])]),_c('div',{staticClass:"slider-holder",style:(`height: ${_vm.boxHeight}px`)},[_c('div',{directives:[{name:"touch",rawName:"v-touch:swipe",value:(_vm.swipeHandler),expression:"swipeHandler",arg:"swipe"}],ref:"inner",staticClass:"slider-inner",class:`a${_vm.active} t${_vm.reviews.length}`},_vm._l((_vm.reviews),function(r,i){return _c('div',{key:i,staticClass:"review"},[_c('div',{staticClass:"author"},[_c('dl',[_c('dt',{staticClass:"review-author"},[_vm._v(_vm._s(r.reviewer_name))]),_c('dd',{staticClass:"rating-container"},[_c('span',{staticClass:"review-stars"},_vm._l((5),function(i){return _c('star',{key:`s${i}`,attrs:{"i":i,"score":r.rating}})}),1)])])]),_c('p',{staticClass:"review-content"},[_vm._v(_vm._s(r.content))])])}),0)])]),_c('div',{staticClass:"slider-footer"},[_c('ul',{staticClass:"slider-dots"},_vm._l((_vm.reviews.length),function(d){return _c('li',{key:`d${d}`,class:{'is-active': d === _vm.active+1},on:{"click":function($event){_vm.active = (d-1)}}})}),0),_c('button',{staticClass:"button large",on:{"click":function($event){$event.preventDefault();return _vm.handleCta()}}},[_vm._v(_vm._s(_vm.label))])])])
}
var ReviewSlidervue_type_template_id_17be09ba_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ReviewSlider.vue?vue&type=template&id=17be09ba

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ReviewSlider.vue?vue&type=script&lang=js



/* harmony default export */ var ReviewSlidervue_type_script_lang_js = ({
	props: ['reviews'],
	components: {
		Star: Star
	},
	computed: {
		boxHeight() {
			return this.heights[this.active];
		},
		label() {
			return this.$reviews.state.ctaLabel
		}
	},
	data() {
		return {
			isTouchScreen: false,
			heights: [],
			active: 0,
			total: this.reviews.length
		}
	},
	methods: {
		handleCta() {
			this.$emit('cta');
		},
		isTouch() {
			let prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

			let mq = function (query) {
				return window.matchMedia(query).matches;
			};

			if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
				return true;
			}

			let query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
			return mq(query);
		},
		left() {
			if(this.active > 0) {
				this.active--;
			}
		},
		right() {
			if(this.active < this.total-1) {
				this.active++;
			} else {
				this.active = 0;
			}
		},
		swipeHandler(direction) {
			if(!this.isTouchScreen) {
				return;
			}

			switch(direction) {
				case 'left':
					this.right();
					break;
				case 'right':
					this.left();
					break;
			}
		},
		daysSince(date2) {
			let date1 = new Date();

			//format to js date
			date2 = new Date(date2);
			
			const ONE_DAY = 1000 * 60 * 60 * 24;
			// Calculate the difference in milliseconds
			const differenceMs = Math.abs(date1 - date2);

			// Convert back to days
			let days = Math.round(differenceMs / ONE_DAY);

			// return days;
			if (days == 0) return "today";
            if (days < 2) return days + " day ago";
            if (days < 7) return days + " days ago";
			if (days < 14) return Math.ceil(days/7) + " week ago";
			if (days < 32) return Math.floor(days/7) + " weeks ago";
			if (days < 62) return Math.floor(days/30) + " month ago";
			if (days < 366) return Math.floor(days/30) + " months ago";
			if (days < 730) return Math.floor(days/365) + " year ago";
			return Math.floor(days/365) + " years ago";
			
		},
		calculateHeights() {
			let reviews = document.querySelectorAll('.review');
			this.heights = [];
			reviews.forEach(r => {
				this.heights.push(r.scrollHeight);
			});
		},
		windowResize(e) {
			this.calculateHeights()

			// check for touch support
			this.isTouchScreen = this.isTouch();
		}
	},
	mounted() {
		//added this for network lag - sometimes heights won't calculate correctly due to styles not being loaded
		setTimeout(() => {
			this.windowResize()
		}, 200);
	},
	created() {
		window.addEventListener("resize", this.windowResize);
	},
	destroyed() {
		window.removeEventListener("resize", this.windowResize);
	},
});

// CONCATENATED MODULE: ./src/components/ReviewSlider.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ReviewSlidervue_type_script_lang_js = (ReviewSlidervue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/ReviewSlider.vue?vue&type=style&index=0&id=17be09ba&prod&lang=scss
var ReviewSlidervue_type_style_index_0_id_17be09ba_prod_lang_scss = __webpack_require__("e7c1");

// CONCATENATED MODULE: ./src/components/ReviewSlider.vue






/* normalize component */

var ReviewSlider_component = normalizeComponent(
  components_ReviewSlidervue_type_script_lang_js,
  ReviewSlidervue_type_template_id_17be09ba_render,
  ReviewSlidervue_type_template_id_17be09ba_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ReviewSlider = (ReviewSlider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GoogleReviews.vue?vue&type=script&lang=js

	
	

	/* harmony default export */ var GoogleReviewsvue_type_script_lang_js = ({
		components: {
			Star: Star,
			ReviewSlider: ReviewSlider,
		},
		computed: {
			reviews() {
				return this.$reviews.state.reviews;
			},
			place() {
				return this.$reviews.state.place;
			},
			loading() {
				return this.$reviews.state.loading;
			}
		},
		methods: {
			handleCta() {
				this.$emit('callback');
			}
		},
		data() {
			return {

			}
		},
		mounted() {
			if(!this.reviews.length) {
				this.$reviews.toggleLoader(true);
				this.$reviews.getReviews()
					.then((res) => {
						this.$reviews.toggleLoader(false);
					})
					.catch(e => {
						// handle error
						// console.log('error getting reviews', e);
					});
			}
		}
	});

// CONCATENATED MODULE: ./src/components/GoogleReviews.vue?vue&type=script&lang=js
 /* harmony default export */ var components_GoogleReviewsvue_type_script_lang_js = (GoogleReviewsvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/components/GoogleReviews.vue?vue&type=style&index=0&id=00c7b4dd&prod&lang=scss
var GoogleReviewsvue_type_style_index_0_id_00c7b4dd_prod_lang_scss = __webpack_require__("dad5");

// CONCATENATED MODULE: ./src/components/GoogleReviews.vue






/* normalize component */

var GoogleReviews_component = normalizeComponent(
  components_GoogleReviewsvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var GoogleReviews = (GoogleReviews_component.exports);
// EXTERNAL MODULE: ./node_modules/vue2-touch-events/index.js
var vue2_touch_events = __webpack_require__("0086");
var vue2_touch_events_default = /*#__PURE__*/__webpack_require__.n(vue2_touch_events);

// CONCATENATED MODULE: ./src/index.js




class src_Reviews {
    constructor(Vue, ctaLabel) {

        // new instance to store the data
        this.storeVM = new Vue({
            data() {
                return {
					reviews: [],
                    place: false,
                    ctaLabel: ctaLabel || '',
                    loading: true,
                };
            },
        });

        this.setReviews = (value) => {
            this.state.reviews = value;
        }

		this.setPlace = (value) => {
			this.state.place = value;
		}

        this.toggleLoader = (value) => {
            this.state.loading = value;
        }

        this.getReviews = () => {

            return new Promise((resolve, reject) => {
                return API.get('https://www.afrihost.com/api/public/google-reviews/reviews')
                    .then(response => {
                        this.setReviews(response.reviews);
                        this.setPlace(response.place);
                        resolve(response);
                    }, error => {
                        reject(error);
                    });
            });
        };
    }

    /**
     * Gets the state of the data
     * @return {Object}
     */
    get state() {
        return this.storeVM.$data;
    }
}

// This exports the plugin object.
/* harmony default export */ var src_0 = ({
    install (Vue, options = {}) {

        if(!options || typeof(options.ctaLabel) == 'undefined') {
            throw new Error('Please initialise plugin with a label for the CTA button');
        }

        Vue.prototype.$reviews = new src_Reviews(
            Vue,
            options.ctaLabel
        );

		// components
		Vue.use(vue2_touch_events_default.a);
        Vue.component('GoogleReviews', GoogleReviews);
    },
});

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ })

/******/ });
//# sourceMappingURL=google-reviews.common.js.map